import React from 'react'
import PropTypes from 'prop-types'
import { FullscreenModal } from 'belle-js'
import connectModal from 'connectModal'
import modalStyles from '../Modals.module.scss'

const SuccessorCustodianInfoModal = (props) => {
  const {
    isOpen,
    closeModal,
    isActiveModal,
  } = props

  return (
    <FullscreenModal
      isOpen={isOpen}
      isActiveModal={isActiveModal}
      className={modalStyles.Modal}
      onClose={closeModal}
      testId="successorCustodianInfoModal">
      <h2>
        What is a successor custodian?
      </h2>

      <p>
        A successor custodian is a contact who can act on this account in the
        event of your incapacity, death, resignation, or removal as custodian.
      </p>

      <p>Things to consider:</p>

      <ul>
        <li>
          This is a nomination only.
        </li>
        <li>
          To activate the role of a successor custodian, you’ll need to change
          the account registration.
        </li>
        <li>
          This designation shall take effect for the account in the event of
          your incapacity, death, resignation, or removal as custodian.
        </li>
      </ul>

      <div className={modalStyles.actions}>
        <button
          type="button"
          className="button button--primary"
          onClick={closeModal}>
          Got it!
        </button>
      </div>
    </FullscreenModal>
  )
}

SuccessorCustodianInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  isActiveModal: PropTypes.bool.isRequired
}


export default connectModal(SuccessorCustodianInfoModal, 'successorCustodianInfoModal')



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modals/SuccessorCustodianInfoModal/SuccessorCustodianInfoModal.jsx